import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

/**
 * Single MSAL instance shared between the React tree (index.js / App) and the RTK base query
 * (services/ClientService.js). Keeping one instance means token refresh and re-authentication are
 * driven off a single source of truth — the base query can silently refresh (or force re-auth)
 * using the same cached account the UI is signed in with.
 *
 * MSAL must be instantiated outside the component tree so it isn't re-created on re-render.
 */
export const msalInstance = new PublicClientApplication(msalConfig);
